import { Quark, HttpGet, HttpResponse, Url } from 'sol-request-angular/dist/comunicacao';
import { environment } from 'src/environments/environment';
import { Injectable } from "@angular/core";
import { GrupoParametro } from '@tivic-team/manager-ts/dist/grl/entities/grupo-parametro.entity';

@Injectable()
export class GrupoParametroController {

    constructor() {}

    async getAll(): Promise<Array<GrupoParametro>> {
        let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'grl/grupoparametro',
					environment: environment
				}),
			}),
			new HttpResponse(
				new Array<GrupoParametro>()
			)
        );
        return await quark.call();
    }
}